module.exports = __webpack_public_path__ + "static/media/jim.74e4236d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/jim.svg
// module id = 296
// module chunks = 0